import { IconProps } from ".";
import { coalColor } from "../../../styles/theme";

export const GraduationHatIcon = ({
  size = 20,
  color = coalColor,
  className,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 0.895508L0.875 4.46842L7 8.04134L12.1042 5.06393V8.80697H13.125V4.46842L7 0.895508ZM2.91617 6.76045V9.06223C3.84738 10.302 5.32998 11.1039 6.9999 11.1039C8.66978 11.1039 10.1524 10.302 11.0836 9.06223L11.0834 6.76086L7.00015 9.14277L2.91617 6.76045Z"
      fill={color}
      strokeWidth="0"
    />
  </svg>
);
